export const gallery = [
  {
    src: require("../assets/gallery/imperial-people.png"),
    caption:
      "My article on Imperial People blog, which details my journey as an apprentice at Imperial College London.",
    link: "https://blogs.imperial.ac.uk/imperial-people/2023/04/03/joyce-kadibu-software-developer-apprentice-information-and-communication-technologies/",
  },
  {
    src: require("../assets/gallery/bloomberg-programme.jpg"),
    caption:
      "Amongst the first cohort for Bloomberg's London in-person Tech Lab programme, collaborating with engineers to build a portfolio manager using Python and Jupyter Notebook.",
    link: "https://www.linkedin.com/posts/jbkad_bloombergtechlab-techatbloomberg-activity-7133499957650558976-0Bab/?utm_medium=member_desktop&utm_source=share",
  },
  {
    src: require("../assets/gallery/imperial-magazine.jpg"),
    caption: "First magazine feature in Imperial Magazine Winter edition 2023.",
    link: "https://www.imperial.ac.uk/be-inspired/magazine/issue-55/education--joyce-kadibu/",
  },
  {
    src: require("../assets/gallery/ed-sec-meeting.jpg"),
    caption:
      "Speaking with the Education Secretary Gillian Keegan about my software engineering apprenticeship journey.",
    link: "https://www.linkedin.com/posts/jbkad_nationalapprenticeshipweek-downingstreet-activity-7030160461534785536-BRvi/?utm_medium=member_desktop&utm_source=share",
  },
  {
    src: require("../assets/gallery/downing-st.jpg"),
    caption: "A visit to Downing Street for National Apprenticeship Week.",
    link: "https://x.com/10DowningStreet/status/1623732997961687041",
  },
  {
    src: require("../assets/gallery/ai-lates.jpg"),
    caption:
      "Volunteering in the monthly Imperial Lates event, where the public had the opportunity to participate in an array of immersive AI activities led by experts in the field.",
    link: "https://www.linkedin.com/posts/jbkad_this-months-imperial-lates-theme-was-ai-activity-7178926272109019136-rWEc/?utm_medium=member_desktop&utm_source=share",
  },
  {
    src: require("../assets/gallery/parliament.jpg"),
    caption:
      "Visiting Parliament to discuss the future of AI with tech experts.",
    link: "https://www.linkedin.com/posts/jbkad_ai-housesofparliament-activity-7178113512940957697-UfW_/?utm_medium=member_desktop&utm_source=share",
  },
  {
    src: require("../assets/gallery/anne-boden-event.jpg"),
    caption:
      "A conversation with Starling Bank founder Anne Boden I hosted for Multiverse Women's Network members to celebrate International Women's Day.",
    link: "https://vimeo.com/927135706/fa0f656e3b",
  },
  {
    src: require("../assets/gallery/multiverse-wic.jpg"),
    caption:
      "A Women's Network event I ran at the Multiverse, featuring esteemed senior panelists who shared valuable insights and expertise with our members.",
    link: "https://www.linkedin.com/posts/jbkad_multiverse-womensnetwork-activity-7189703395719438336-6zPg/?utm_medium=member_desktop&utm_source=share",
  },
  {
    src: require("../assets/gallery/christ-church-visit.jpg"),
    caption:
      "A career panel talk I participated in at Christ's Hospital school, where I gave insights into my journey to becoming a software engineer to year 11-13 students.",
    link: "https://www.linkedin.com/posts/jbkad_apprenticeships-ban-christshospital-activity-7194010695544225793-sZSH/?utm_medium=member_desktop&utm_source=share",
  },
  {
    src: require("../assets/gallery/apprenticeship.jpg"),
    caption:
      "Amongst the first cohort for Imperial's new apprenticeship course with Multiverse, which provides a unique split learning model that combines hands-on workplace experience with formal education in computer science theory.",
    link: "",
  },
  {
    src: require("../assets/gallery/acstem.jpg"),
    caption:
      "Facilitating a panel at the inagural Imperial College ACSTEM, an outreach conference aimed at year 12s students of African-Caribbean heritage wishing to persue a career in STEM.",
    link: "https://www.linkedin.com/posts/imperial-college-london-afro-caribbean-society-9a85a424a_acstem-imperial-africancaribbeansociety-activity-7224119405394235394-MlmW/?utm_medium=member_desktop&utm_source=share",
  },
  {
    src: require("../assets/gallery/manageable.jpg"),
    caption:
      "Hosting a fireside chat workshop in collaboration with Manageable at the Google London headquarters for Multiverse Women’s Network members.",
    link: "https://www.linkedin.com/posts/jbkad_multiverse-multiversewomensnetwork-careercoaching-activity-7140723156209516545-olxi/?utm_medium=member_desktop&utm_source=share",
  },
  {
    src: require("../assets/gallery/white-city-workshop.jpg"),
    caption:
      "Hosted a Tech workshop at Imperial College London aimed at fostering the curiosity of local youth towards pursuing careers in STEM.",
    link: "https://www.linkedin.com/posts/jbkad_imperialcollegelondon-stemeducation-techcareers-activity-7062058541993353216-fHcp/?utm_medium=member_desktop&utm_source=share",
  },
  {
    src: require("../assets/gallery/everywoman-in-tech.png"),
    caption:
      "Nominated as a Rising Star in the Everywoman in Tech Awards 2025.",
    link: "https://www.linkedin.com/posts/imperial-college-london_from-apprentice-software-engineer-to-a-activity-7305180939960135681-ykTE?utm_source=share&utm_medium=member_desktop&rcm=ACoAADkdgFYB-1jGyKaWWWX7GAFIGNzDzIOFEmU",
  },
  {
    src: require("../assets/gallery/girls-into-coding.jpg"),
    caption:
      "Supporting girls aged 10-14 through Tech for Change, a STEM outreach programme in partnership with the Royal Academy of Engineering and the Department for Science, Innovation and Technology.",
    link: "https://www.linkedin.com/posts/girls-into-coding_techforchange-empoweringgirls-raengingenious-activity-7348259728419876865-Ay57?utm_source=share&utm_medium=member_desktop&rcm=ACoAADkdgFYB-1jGyKaWWWX7GAFIGNzDzIOFEmU",
  },
  //   {
  //     src: require("../assets/gallery/"),
  //     caption: "",
  //     link: "",
  //   },
];
